import { emailWarning } from "@/lib/emailCheck";

// Under a staff email field: a likely typo (gmail.co, gmial.com, a name one letter off) with a one-tap fix,
// so the member's bill doesn't go to an address that doesn't exist.
export default function EmailTypoHint({ email, name, onFix, testid }) {
  const w = emailWarning(email, name);
  if (!w) return null;
  return (
    <p className="text-[11px] text-amber-300 mt-1" data-testid={testid}>
      {w.message}{" "}
      {w.suggestion && <button type="button" className="underline break-all" onClick={() => onFix(w.suggestion)}>Use {w.suggestion}</button>}
    </p>
  );
}
